import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Badge, ProgressBar, Table } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../Styles/HairRemovalStyle.css";
import hairRemovalHero from '../Assets/EPDEVICE.png';
// import treatmentProcess from '../Assets/treatment-process.jpg';
import beforeAfter from '../Assets/laserbfr.png';
import rectangleSpot from '../Assets/EPRECTANLGE.png';
import dualHand from '../Assets/EPHANDPIECE.png';
// import spotCover from '../Assets/spot-cover.png';
import coolingSystem from '../Assets/EPCOOLING.png';
// import profitChart from '../Assets/profit-chart.png';
// import skinAnalysis from '../Assets/skin-analysis.png';
import backgroundImage from '../Assets/lasback.png';

const HairRemovalPage = () => {
  const [activeFeature, setActiveFeature] = useState('rectangle');
  const [treatmentArea, setTreatmentArea] = useState('full-body');
  const [pulseType, setPulseType] = useState('short');
  const [profitMargin, setProfitMargin] = useState(95);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: false
    });
  }, []);

  const handleOpenPDF = () => {
  // Using fetch to get the file as blob
  fetch("https://romanqadir.github.io/jsonapi/catalogue.pdf")
    .then(response => response.blob())
    .then(blob => {
      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'hair-removal.pdf'; // Specify the filename for download
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the blob URL
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Download failed:', error);
      // Fallback to opening in new tab if download fails
      window.open("https://romanqadir.github.io/jsonapi/catalogue.pdf", '_blank');
    });
};

  
 
  // Key Features from Catalogue
  const keyFeatures = [
    {
      id: 1,
      title: "Advanced Air-Cooling",
      description: "-35°C continuous cooling for superior comfort",
      icon: "fas fa-snowflake",
      value: "-35°C"
    },
    {
      id: 2,
      title: "Dual-Hand Technology",
      description: "Continuous operation, zero downtime",
      icon: "fas fa-hand-paper",
      value: "2 Handpieces"
    },
    {
      id: 3,
      title: "High Frequency",
      description: "3Hz frequency for faster treatments",
      icon: "fas fa-tachometer-alt",
      value: "3Hz"
    },
    {
      id: 4,
      title: "Rectangular Spot",
      description: "15×50mm spot for efficient coverage",
      icon: "fas fa-square",
      value: "15×50mm"
    },
    {
      id: 5,
      title: "Energy Saving",
      description: "Inverter motor, low energy consumption",
      icon: "fas fa-bolt",
      value: "22A"
    },
    {
      id: 6,
      title: "Silent System",
      description: "Quiet operation for patient comfort",
      icon: "fas fa-volume-mute",
      value: "<45dB"
    }
  ];

  // Spot Size Comparison
  const spotComparison = [
    {
      type: "Rectangle Spot",
      advantages: [
        "Faster uniform coverage",
        "No overlap needed",
        "No missed areas",
        "No burns",
        "Deeper penetration"
      ],
      efficiency: "99%",
      satisfaction: "99% Positive Feedback"
    },
    {
      type: "Circle Spot",
      disadvantages: [
        "Overlap causes burns",
        "Missed areas require retouch",
        "Slower coverage",
        "Inefficient pattern"
      ],
      efficiency: "85%",
      satisfaction: "80% Positive Feedback"
    }
  ];

  // Treatment Areas
  const treatmentAreas = [
    {
      area: "Full Body",
      time: "30-40 min",
      coverage: "Complete",
      color: "#FF6B6B",
      icon: "fas fa-user-md"
    },
    {
      area: "Facial",
      time: "5 min",
      coverage: "Precise",
      color: "#4ECDC4",
      icon: "fas fa-smile"
    },
    {
      area: "Bikini",
      time: "3 min",
      coverage: "Sensitive",
      color: "#FFD166",
      icon: "fas fa-heart"
    },
    {
      area: "Underarms",
      time: "3 min",
      coverage: "Quick",
      color: "#95E1D3",
      icon: "fas fa-hand-paper"
    }
  ];

  // Pulse Technology Types
  const pulseTechnologies = [
    {
      type: "Short Pulse",
      duration: "1-3ms",
      effect: "High peak power, rapid heating",
      benefit: "Effective for fine hair",
      diagram: "temperature-graph",
      active: pulseType === 'short'
    },
    {
      type: "Long Pulse",
      duration: "6-8ms",
      effect: "Heat dissipation, safer",
      benefit: "Ideal for dark skin",
      diagram: "power-graph",
      active: pulseType === 'long'
    },
    {
      type: "Pulse Train",
      duration: "Multiple pulses",
      effect: "Enhanced safety",
      benefit: "Balanced effectiveness",
      diagram: "train-graph",
      active: pulseType === 'train'
    }
  ];

  // Profit Analysis
  const profitAnalysis = [
    { category: "Device Cost", value: 5, color: "#FF6B6B" },
    { category: "Lamp Cost", value: 10, color: "#4ECDC4" },
    { category: "Operational", value: 10, color: "#FFD166" },
    { category: "PROFIT", value: 75, color: "#95E1D3" }
  ];

  // Clinical Results
  const clinicalResults = [
    { session: "After 1st Session", reduction: "60-80%", satisfaction: "85%" },
    { session: "After 3rd Session", reduction: "85-90%", satisfaction: "92%" },
    { session: "After 5th Session", reduction: "90-95%", satisfaction: "97%" },
    { session: "Maintenance", reduction: "98-99%", satisfaction: "99%" }
  ];

  return (
    <div className="hair-removal-page">
      {/* Hero Section */}
      <section 
        className="hair-hero-section" 
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <Container>
          <Row className="align-items-center min-vh-100">
            <Col lg={6} className="hero-content" data-aos="fade-right">
              <Badge bg="dark" text="light" className="mb-3 pro-badge" data-aos="fade-up">
                <i className="fas fa-crown me-2"></i>
                PRO SERIES 2025
              </Badge>
              
              <h1   >
                EPILYUM PRO
              </h1>
              <h2  className="product-subtitle typed-text">
                Advanced Laser Hair Removal System
              </h2>
              
              <p className="hero-tagline" data-aos="fade-up" data-aos-delay="200">
                Experience the confidence of flawless skin with our clinically proven laser treatments
              </p>
              
              <div className="hero-stats" data-aos="fade-up" data-aos-delay="300">
                <div className="stat">
                  <div className="stat-number">5000W</div>
                  <div className="stat-label">Maximum Power</div>
                </div>
                <div className="stat">
                  <div className="stat-number">30min</div>
                  <div className="stat-label">Full Body Time</div>
                </div>
                <div className="stat">
                  <div className="stat-number">95%</div>
                  <div className="stat-label">Profit Margin</div>
                </div>
              </div>
            </Col>
            
            <Col lg={6} className="text-center" data-aos="fade-left" data-aos-delay="400">
              <div className="device-display">
                <Image 
                  src={hairRemovalHero} 
                  fluid 
                  className="product-hero-image hair-glow" 
                  alt="Epilyum Pro Hair Removal Device"
                />
                
                {/* Floating Elements */}
                <div className="floating-elements">
                  <div className="float-element cooling" data-aos="fade-down-right">
                    <i className="fas fa-snowflake"></i>
                    <span>-35°C</span>
                  </div>
                  <div className="float-element frequency" data-aos="fade-up-right">
                    <i className="fas fa-tachometer-alt"></i>
                    <span>3Hz</span>
                  </div>
                  <div className="float-element spot" data-aos="fade-down-left">
                    <i className="fas fa-expand"></i>
                    <span>15×50mm</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        
        {/* Scroll Indicator */}
        <div className="scroll-indicator" data-aos="fade-up" data-aos-delay="600">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
        </div>
      </section>

      {/* Key Features Grid */}
      <section className="features-section py-6">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title hair-title" data-aos="fade-up">
                <br></br>
                Revolutionary <span className="text-highlight">Technology</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
              <p className="lead" data-aos="fade-up" data-aos-delay="200">
                Unmatched speed, power, and precision for superior hair removal
              </p>
            </Col>
          </Row>
          
          <Row className="g-4">
            {keyFeatures.map((feature, index) => (
              <Col md={6} lg={4} key={feature.id} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className={feature.icon}></i>
                  </div>
                  <div className="feature-content">
                    <h5>{feature.title}</h5>
                    <p>{feature.description}</p>
                    <div className="feature-value">{feature.value}</div>
                  </div>
                  <div className="feature-wave">
                    <div className="wave"></div>
                    <div className="wave"></div>
                    <div className="wave"></div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Rectangle Spot Technology */}
      <section className="spot-technology-section py-6 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <div className="spot-visualization">
                <Image 
                  src={rectangleSpot} 
                  fluid 
                  className="spot-image" 
                  alt="Rectangle Spot Technology"
                />
                {/* <div className="spot-animation">
                  <div className="scan-line"></div>
                  <div className="scan-line delay-1"></div>
                  <div className="scan-line delay-2"></div>
                </div> */}
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <h2 className="section-title hair-title mb-4">
                Revolutionary <span className="text-highlight">Rectangle Spot</span>
              </h2>
              <div className="divider mb-4"></div>
              
              <p className="mb-4">
                The revolutionary rectangle spot provides faster and uniform coverage 
                of the treatment area with larger spots, penetrating deeper. No overlap, 
                no burns, and no retouching missed areas.
              </p>
              
              <div className="comparison-grid">
                {spotComparison.map((spot, index) => (
                  <div key={index} className={`comparison-card ${index === 0 ? 'preferred' : ''}`}>
                    <h5>{spot.type}</h5>
                    <ul>
                      {index === 0 ? 
                        spot.advantages.map((adv, i) => (
                          <li key={i}><i className="fas fa-check"></i> {adv}</li>
                        )) :
                        spot.disadvantages.map((dis, i) => (
                          <li key={i}><i className="fas fa-times"></i> {dis}</li>
                        ))
                      }
                    </ul>
                    <div className="efficiency-badge">
                      {spot.efficiency} Efficiency
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Dual Handpiece System */}
      <section className="handpiece-section py-6">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <div className="handpiece-visual">
                <Image 
                  src={dualHand} 
                  fluid 
                  className="handpiece-image" 
                  alt="Dual Handpiece System"
                />
                <div className="handpiece-glow"></div>
              </div>
              
              <div className="spot-covers mt-5">
                <div className="cover-card" data-aos="fade-up">
                  <div className="cover-icon">
                    <i className="fas fa-expand"></i>
                  </div>
                  <h6>Full-Body Spot Cover</h6>
                  <p>Designed for larger areas, maximizing efficiency</p>
                </div>
                <div className="cover-card" data-aos="fade-up" data-aos-delay="100">
                  <div className="cover-icon">
                    <i className="fas fa-smile"></i>
                  </div>
                  <h6>Facial Spot Cover</h6>
                  <p>Smaller for precise targeting in delicate areas</p>
                </div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <h2 className="section-title hair-title mb-4">
                <span className="text-highlight">Dual-Hand</span> Technology
              </h2>
              <div className="divider mb-4"></div>
              
              <p className="mb-4">
                Epilyum features a dual-handpiece design that minimizes service downtime, 
                ensuring continuous operation and maximum productivity.
              </p>
              
              <div className="benefits-list">
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <i className="fas fa-sync-alt"></i>
                  </div>
                  <div>
                    <h5>Zero Downtime</h5>
                    <p>Continuous operation with automatic switching</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <i className="fas fa-shield-alt"></i>
                  </div>
                  <div>
                    <h5>Anti-Bacteria Cover</h5>
                    <p>Single-use silicone covers for optimal hygiene</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <i className="fas fa-bolt"></i>
                  </div>
                  <div>
                    <h5>High Efficiency</h5>
                    <p>25% faster treatments with dual handpieces</p>
                  </div>
                </div>
              </div>
              
              <div className="hygiene-badge">
                <i className="fas fa-bacteria"></i>
                <span>Anti-bacterial protection</span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Advanced Cooling System */}
      <section className="cooling-section py-6 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <h2 className="section-title hair-title mb-4">
                Advanced <span className="text-highlight">Air-Cooling</span> System
              </h2>
              <div className="divider mb-4"></div>
              
              <p className="mb-4">
                Epilyum integrates advanced air cooling technology to deliver continuous 
                epidermal protection and superior patient comfort, enabling safe, 
                high-efficiency treatments at -35°C.
              </p>
              
              <div className="cooling-stats">
                <div className="cooling-stat">
                  <div className="stat-number">-35°C</div>
                  <div className="stat-label">Cooling Temperature</div>
                </div>
                <div className="cooling-stat">
                  <div className="stat-number">100%</div>
                  <div className="stat-label">Patient Comfort</div>
                </div>
                <div className="cooling-stat">
                  <div className="stat-number">0</div>
                  <div className="stat-label">Burn Cases</div>
                </div>
              </div>
              
              <div className="comfort-features">
                <div className="feature-tag">
                  <i className="fas fa-check"></i> Continuous cooling
                </div>
                <div className="feature-tag">
                  <i className="fas fa-check"></i> No numbing cream needed
                </div>
                <div className="feature-tag">
                  <i className="fas fa-check"></i> Suitable for all skin types
                </div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <div className="cooling-visual">
                <Image 
                  src={coolingSystem} 
                  fluid 
                  className="cooling-image" 
                  alt="Advanced Cooling System"
                />
                <div className="temperature-display">
                  <div className="temp-value">-35°C</div>
                  <div className="temp-label">Active Cooling</div>
                </div>
                <div className="cold-waves">
                  <div className="wave"></div>
                  <div className="wave"></div>
                  <div className="wave"></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Pulse Technology Interactive */}
      <section className="pulse-technology-section py-6">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title hair-title" data-aos="fade-up">
                <br></br>
                Intelligent <span className="text-highlight">Pulse Technology</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
              <p className="lead" data-aos="fade-up" data-aos-delay="200">
                Optimized pulse durations for different hair types and skin tones
              </p>
            </Col>
          </Row>
          
          <Row className="mb-5">
            <Col lg={12}>
              <div className="pulse-tabs" data-aos="fade-up">
                {pulseTechnologies.map((tech, index) => (
                  <button
                    key={index}
                    className={`pulse-tab ${tech.active ? 'active' : ''}`}
                    onClick={() => setPulseType(tech.type.toLowerCase().split(' ')[0])}
                  >
                    <i className="fas fa-wave-square me-2"></i>
                    {tech.type}
                  </button>
                ))}
              </div>
            </Col>
          </Row>
          
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <div className="pulse-visualization">
                <div className={`pulse-diagram ${pulseType}-pulse`}>
                  <div className="pulse-wave"></div>
                  <div className="pulse-wave delay-1"></div>
                  <div className="pulse-wave delay-2"></div>
                  <div className="energy-bar"></div>
                </div>
                
                <div className="pulse-info">
                  {pulseTechnologies.find(t => t.active) && (
                    <>
                      <div className="info-item">
                        <span>Pulse Duration:</span>
                        <strong>{pulseTechnologies.find(t => t.active).duration}</strong>
                      </div>
                      <div className="info-item">
                        <span>Effect:</span>
                        <strong>{pulseTechnologies.find(t => t.active).effect}</strong>
                      </div>
                      <div className="info-item">
                        <span>Benefit:</span>
                        <strong>{pulseTechnologies.find(t => t.active).benefit}</strong>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <div className="pulse-explanation">
                <h4 className="mb-4">Superior Effectiveness on Fine Hair</h4>
                
                <div className="explanation-points">
                  <div className="point">
                    <div className="point-icon">
                      <i className="fas fa-thermometer-full"></i>
                    </div>
                    <div>
                      <h5>Shorter Pulse Durations</h5>
                      <p>Higher peak power and increased temperature prevents heat from escaping, ensuring effective follicle destruction</p>
                    </div>
                  </div>
                  
                  <div className="point">
                    <div className="point-icon">
                      <i className="fas fa-thermometer-half"></i>
                    </div>
                    <div>
                      <h5>Longer Pulse Durations</h5>
                      <p>More heat dissipation, reducing peak temperature for safer treatment on darker skin types</p>
                    </div>
                  </div>
                  
                  <div className="point">
                    <div className="point-icon">
                      <i className="fas fa-wave-square"></i>
                    </div>
                    <div>
                      <h5>Pulse Train Duration</h5>
                      <p>Multiple short pulses with delays enhance safety while maintaining effectiveness</p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Treatment Efficiency */}
      <section className="efficiency-section py-6 bg-light">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title hair-title" data-aos="fade-up">
                Unmatched <span className="text-highlight">Treatment Efficiency</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="g-4">
            {treatmentAreas.map((area, index) => (
              <Col md={6} lg={3} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <div 
                  className={`area-card ${treatmentArea === area.area.toLowerCase().replace(' ', '-') ? 'active' : ''}`}
                  onClick={() => setTreatmentArea(area.area.toLowerCase().replace(' ', '-'))}
                >
                  <div className="area-icon" style={{ color: area.color }}>
                    <i className={area.icon}></i>
                  </div>
                  <h5>{area.area}</h5>
                  <div className="area-time">{area.time}</div>
                  <div className="area-coverage">{area.coverage} Coverage</div>
                  <div className="area-progress">
                    <div className="progress-bar" style={{ 
                      width: area.area === 'Full Body' ? '100%' : 
                             area.area === 'Facial' ? '40%' :
                             area.area === 'Bikini' ? '60%' : '30%',
                      background: area.color
                    }}></div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          
          {/* Treatment Results */}
          <Row className="mt-6">
            <Col lg={12}>
              <div className="results-table" data-aos="fade-up">
                <h4 className="mb-4 text-center">Clinical Results Timeline</h4>
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Treatment Session</th>
                        <th>Hair Reduction</th>
                        <th>Patient Satisfaction</th>
                        <th>Average Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clinicalResults.map((result, index) => (
                        <tr key={index}>
                          <td>
                            <div className="session-badge">
                              <i className="fas fa-calendar-check"></i>
                              {result.session}
                            </div>
                          </td>
                          <td>
                            <div className="reduction-badge">
                              {result.reduction}
                              <div className="progress">
                                <div 
                                  className="progress-bar" 
                                  style={{ 
                                    width: result.reduction.split('-')[0].replace('%', '') + '%'
                                  }}
                                ></div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="satisfaction">
                              {result.satisfaction}
                              <div className="stars">
                                <i className="fas fa-star"></i>
                                <i className="fas fa-star"></i>
                                <i className="fas fa-star"></i>
                                <i className="fas fa-star"></i>
                                <i className="fas fa-star"></i>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="time-estimate">
                              <i className="fas fa-clock"></i>
                              {result.session.includes('1st') ? '30-40min' :
                               result.session.includes('3rd') ? '15-20min' :
                               result.session.includes('6th') ? '10-15min' : '5-10min'}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Profit Analysis */}
      <section className="profit-section py-6">
       
      </section>

      {/* Before/After Comparison */}
      <section className="before-after-section py-6 bg-light">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title hair-title" data-aos="fade-up">
                Clinical <span className="text-highlight">Results</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
              <p className="lead" data-aos="fade-up" data-aos-delay="200">
                See the transformation with Epilyum Pro Series 2025
              </p>
            </Col>
          </Row>
          
          <Row>
            <Col lg={8}>
              <div className="before-after-container" data-aos="zoom-in" >
                  <Image 
                      src={beforeAfter} 
                      fluid 
                      alt="Hair Removal Results"
                    
                    />
                
                {/* Treatment Parameters */}
                <div className="treatment-params mt-4">
                  <div className="param-card">
                    <div className="param-icon">
                      <i className="fas fa-wave-square"></i>
                    </div>
                    <div>
                      <div className="param-value">6ms</div>
                      <div className="param-label">Pulse Duration</div>
                    </div>
                  </div>
                  <div className="param-card">
                    <div className="param-icon">
                      <i className="fas fa-tachometer-alt"></i>
                    </div>
                    <div>
                      <div className="param-value">1Hz</div>
                      <div className="param-label">Frequency</div>
                    </div>
                  </div>
                  <div className="param-card">
                    <div className="param-icon">
                      <i className="fas fa-bolt"></i>
                    </div>
                    <div>
                      <div className="param-value">4J</div>
                      <div className="param-label">Energy</div>
                    </div>
                  </div>
                  <div className="param-card">
                    <div className="param-icon">
                      <i className="fas fa-snowflake"></i>
                    </div>
                    <div>
                      <div className="param-value">-35°C</div>
                      <div className="param-label">Cooling</div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Technical Specifications */}
      <section className="specs-section py-6">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 style={{color:'white'}} className="section-title hair-title" data-aos="fade-up">
                <br></br>
                Technical <span  className="text-highlight">Specifications</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row>
            <Col lg={12}>
              <div className="specs-card" data-aos="fade-up">
                <div className="specs-header">
                  <h4>EPILYUM PRO SERIES 2025</h4>
                  <Badge bg="success">CE & BELTCERT Certified</Badge>
                </div>
                
                <div className="specs-grid">
                  <div className="spec-item">
                    <div className="spec-label">
                      <i className="fas fa-wave-square"></i>
                      Wavelength
                    </div>
                    <div className="spec-value">500 - 1200 nm</div>
                  </div>
                  <div className="spec-item">
                    <div className="spec-label">
                      <i className="fas fa-tachometer-alt"></i>
                      Maximum Frequency
                    </div>
                    <div className="spec-value">1 - 10 Hz (10 shots/sec)</div>
                  </div>
                  <div className="spec-item">
                    <div className="spec-label">
                      <i className="fas fa-bolt"></i>
                      Laser Energy
                    </div>
                    <div className="spec-value">1 - Over 100 J</div>
                  </div>
                  <div className="spec-item">
                    <div className="spec-label">
                      <i className="fas fa-plug"></i>
                      Device Power
                    </div>
                    <div className="spec-value">5000W</div>
                  </div>
                  <div className="spec-item">
                    <div className="spec-label">
                      <i className="fas fa-clock"></i>
                      Pulse Duration
                    </div>
                    <div className="spec-value">1 - 8 ms</div>
                  </div>
                  <div className="spec-item">
                    <div className="spec-label">
                      <i className="fas fa-expand"></i>
                      Spot Size
                    </div>
                    <div className="spec-value">15 mm × 50 mm</div>
                  </div>
                  <div className="spec-item">
                    <div className="spec-label">
                      <i className="fas fa-bolt"></i>
                      Voltage
                    </div>
                    <div className="spec-value">220V</div>
                  </div>
                  <div className="spec-item">
                    <div className="spec-label">
                      <i className="fas fa-certificate"></i>
                      Certifications
                    </div>
                    <div className="spec-value">CE & BELTCERT</div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Catalog Download */}
      <section className="catalog-section py-6 bg-light">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center" data-aos="fade-up">
              <h2 className="section-title hair-title mb-4">
                Download <span className="text-highlight">Complete Catalogue</span>
              </h2>
              <div className="divider mb-5"></div>
              
              <div className="catalog-preview" data-aos="zoom-in">
                <div className="catalog-cover">
                  <div className="cover-content">
                    <h3>EPILYUM PRO SERIES 2025</h3>
                    <p>Advanced Laser Hair Removal System</p>
                    <div className="cover-features">
                      <span><i className="fas fa-check"></i> 5000W Power</span>
                      <span><i className="fas fa-check"></i> -35°C Cooling</span>
                      <span><i className="fas fa-check"></i> 95% Profit</span>
                    </div>
                  </div>
                  <div className="cover-glow"></div>
                </div>
                
                <button 
                  onClick={handleOpenPDF}
                  className="btn btn-primary btn-lg download-btn mt-5"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <i className="fas fa-download me-2"></i>
                  Download Full Catalogue (PDF)
                </button>
                
                <p className="mt-3 text-muted" data-aos="fade-up" data-aos-delay="300">
                  <small>Includes complete technical specifications and clinical protocols</small>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default HairRemovalPage;